<div class="w-full space-y-6 animate-fade-in">
  @if (isLoading()) {
    <!-- Loading state -->
    <div class="text-center md:text-left space-y-4">
      <div class="mx-auto md:mx-0 flex items-center justify-center h-16 w-16 rounded-full bg-primary-100">
        <i class="pi pi-spin pi-spinner text-2xl text-primary-600"></i>
      </div>

      <h2 class="text-2xl font-bold text-greyscale-900">
        {{ 'emailVerification.verifying' | transloco }}
      </h2>

      <p class="text-paragraph-reg text-greyscale-600">
        {{ 'emailVerification.pleaseWait' | transloco }}
      </p>
    </div>

  } @else if (isSuccess()) {
    <!-- Success state -->
    <div class="text-center md:text-left space-y-4">
      <div class="mx-auto md:mx-0 flex items-center justify-center h-16 w-16 rounded-full bg-validation-100">
        <i class="pi pi-check text-2xl text-validation-600"></i>
      </div>

      <h2 class="text-2xl font-bold text-greyscale-900">
        {{ 'emailVerification.emailVerified' | transloco }}
      </h2>

      <p class="text-paragraph-reg text-greyscale-600">
        {{ 'emailVerification.successMessage' | transloco }}<br>
        {{ 'emailVerification.canLogin' | transloco }}
      </p>

      <button
        type="button"
        (click)="goToLogin()"
        class="flex w-full justify-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
      >
        <i class="pi pi-sign-in mr-2"></i>
        {{ 'emailVerification.continueToLogin' | transloco }}
      </button>
    </div>

  } @else {
    <!-- Error state -->
    <div class="text-center md:text-left space-y-4">
      <div class="mx-auto md:mx-0 flex items-center justify-center h-16 w-16 rounded-full bg-error-100">
        <i class="pi pi-times text-2xl text-error-600"></i>
      </div>

      <h2 class="text-2xl font-bold text-greyscale-900">
        {{ 'emailVerification.verificationFailed' | transloco }}
      </h2>

      <div class="rounded-md bg-error-50 border border-error-200 p-4">
        <p class="text-paragraph-s-reg text-error-800">
          {{ errorMessage() }}
        </p>
      </div>

      <button
        type="button"
        (click)="goToRegister()"
        class="flex w-full justify-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
      >
        <i class="pi pi-refresh mr-2"></i>
        {{ 'emailVerification.requestNewVerification' | transloco }}
      </button>

      <!-- Links -->
      <div class="flex flex-col items-center md:items-start gap-2">
        <a
          class="text-sm font-medium text-primary-600 no-underline hover:text-primary-500 flex items-center"
          routerLink="/auth/login"
        >
          <i class="pi pi-arrow-left mr-2"></i>
          {{ 'emailVerification.backToLogin' | transloco }}
        </a>
      </div>
    </div>
  }

  <p-toast />
</div>